import React from 'react'
import type { CellProps } from 'react-table'
import LinkCell from '../../Generics/GenericLinkCell'
import type { SearchVehicle } from '../types'

export const MakeModelYearCellWithAsset = ({
    row: {
        original: { assetId },
    },
    cell: { value },
}: CellProps<SearchVehicle>): React.ReactNode =>
    assetId && <LinkCell href={`/details/vehicles?id=${assetId}`}>{value}</LinkCell>
